<template>
  <div class="tickets-check-dialog">
    <el-dialog v-dialog-drag :title="readonly ? '退票详情' : title" :visible.sync="showDialog" width="850px" :destroy-on-close="true"
      :before-close="cancel" class="audit-dialog">
      <div class="el-dialog-div">
        <!-- 审核操作区域 -->
        <div class="section-card audit-section" v-if="!readonly">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-s-check"></i> 审核操作</span>
            <el-button size="small" type="success" icon="el-icon-check" @click="handle">确认审核</el-button>
          </div>
          <el-form label-width="80px" ref="form" :model="form" :rules="rules" class="audit-form">
            <el-form-item label="审核结果" prop="status">
              <el-radio v-model="form.status" label="SUCCESS">
                <i class="el-icon-success" style="color: #67c23a;"></i> 通过
              </el-radio>
              <el-radio v-model="form.status" label="DEFEAT">
                <i class="el-icon-error" style="color: #f56c6c;"></i> 驳回
              </el-radio>
            </el-form-item>
            <el-form-item v-if="form.status === 'DEFEAT'" label="驳回原因" prop="rejectionReason">
              <el-input type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 3 }" placeholder="请输入内容"
                v-model="form.rejectionReason" clearable>
              </el-input>
            </el-form-item>
          </el-form>
        </div>

        <!-- 退票申请信息 -->
        <div class="section-card">
          <div class="section-header-bar" @click="toggleSection('refundInfo')">
            <div class="section-title"><i class="el-icon-info"></i> 退票申请信息</div>
            <i :class="sectionOpen.refundInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="detail-grid" v-show="sectionOpen.refundInfo">
            <div class="detail-item">
              <span class="detail-label">退票创建人</span>
              <span class="detail-value">{{ invoiceInfo.refundPersonName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">退票申请时间</span>
              <span class="detail-value">{{ invoiceInfo.refundTime }}</span>
            </div>
            <div class="detail-item full-width">
              <span class="detail-label">申请退票原因</span>
              <span class="detail-value">{{ invoiceInfo.refundReason }}</span>
            </div>
          </div>
        </div>

        <!-- 发票信息 -->
        <div class="section-card">
          <div class="section-header-bar" @click="toggleSection('invoiceInfo')">
            <div class="section-title"><i class="el-icon-document"></i> 发票信息</div>
            <i :class="sectionOpen.invoiceInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
          <div class="detail-grid" v-show="sectionOpen.invoiceInfo">
            <div class="detail-item full-width">
              <span class="detail-label">发票号码</span>
              <span class="detail-value">{{ invoiceInfo.invoiceNumber }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">发票抬头</span>
              <span class="detail-value">{{ invoiceInfo.invoiceTitle }}</span>
            </div>
            <div class="detail-item" v-if="invoiceInfo.invoiceStatus !== ''">
              <span class="detail-label">发票状态</span>
              <span class="detail-value">
                <el-tag :type="getInvoiceColor(invoiceInfo.invoiceStatus, 'tagType')"
                  :style="{ color: getInvoiceColor(invoiceInfo.invoiceStatus, 'color'), 'background-color': getInvoiceColor(invoiceInfo.invoiceStatus, 'backgroundColor') }">
                  {{ getInvoiceColor(invoiceInfo.invoiceStatus, 'name') }}</el-tag>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">发票类型</span>
              <span class="detail-value">{{ invoiceInfo.invoiceType }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">发票金额</span>
              <span class="detail-value"><span class="amount-text">{{ invoiceInfo.invoiceAmount }}</span></span>
            </div>
            <div class="detail-item full-width">
              <span class="detail-label">对应合同号</span>
              <span class="detail-value">
                <div v-for="(contractNumber, index) in invoiceInfo.contractNumbers" :key="'contract' + index">
                  <el-link :underline="false" type="primary" @click="openContractDialog(contractNumber)">{{
                    contractNumber }}</el-link>
                </div>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-label">发票创建人</span>
              <span class="detail-value">{{ invoiceInfo.createBy }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">发票创建时间</span>
              <span class="detail-value">{{ invoiceInfo.createTime }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">开票公司</span>
              <span class="detail-value">{{ invoiceInfo['billingUnit'].companyName }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">销售</span>
              <span class="detail-value">{{ invoiceInfo['sale'].name }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">负责人</span>
              <span class="detail-value">{{ invoiceInfo['invoicingPrincipal'].name }}</span>
            </div>
            <div class="detail-item" v-if="invoiceInfo.appendix">
              <span class="detail-label">发票</span>
              <span class="detail-value">
                <div class="attachment-actions">
                  <el-button size="mini" type="primary" icon="el-icon-download"
                    @click="download(invoiceInfo.id)">下载</el-button>
                  <el-button size="mini" type="primary" icon="el-icon-view"
                    @click="preview(invoiceInfo.id)">预览</el-button>
                </div>
              </span>
            </div>
            <div class="detail-item full-width">
              <span class="detail-label">备注</span>
              <span class="detail-value">{{ invoiceInfo.remark }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <contract-details v-if="showContractDetails" :show-dialog="showContractDetails" :select-detail="[ContractDetail]"
      @submit="close1"></contract-details>
    <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>

import { attachmentTickets, refundAudit } from "@/api/dilivery/tickets";
import { fileDownload } from "@/utils/downFileUtils";
import FilePreview from "@/components/file/FilePreview.vue";
import { getContractPage } from "@/api/dilivery/sales/contract";
import ContractDetails from "@/components/sales/ContractDetails.vue";
import { getInvoiceColor } from "@/color";
import { getDataInLocalStorage } from "@/utils/localStorage";
import Loading from "@/components/loading/Loading.vue";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "TicketsCheckDialog",
  components: { ContractDetails, FilePreview, Loading },
  props: ['showDialog', 'selectDetail', 'readonly'],
  data() {
    return {
      title: '退票审核',
      showFile: false,
      loading: false,
      fileInfo: '',
      sectionOpen: {
        refundInfo: true,
        invoiceInfo: true,
      },
      showContractDetails: false,
      ContractDetail: '',
      invoiceInfo: {},
      form: {
        id: '',
        status: '',
        rejectionReason: ''
      },
      rules: {
        status: [
          { required: true, message: '审核结果不能为空', trigger: 'change' }
        ],
        rejectionReason: [
          { required: true, message: '驳回原因不能为空', trigger: 'change' }
        ],
      }
    }
  },
  mounted() {
  },
  watch: {
    'selectDetail': {
      handler(newVal) {
        if (newVal && Object.keys(newVal)) {
          // if (newVal.appendix !== null) {
          //   this.invoiceInfo.appendix = newVal.appendix
          // }
          this.form.id = newVal.id
          this.invoiceInfo = { ...newVal }
          // this.invoiceInfo.id = newVal.id
          // if (newVal.refundAuditStatus !== null) {
          //   this.invoiceInfo.refundAuditStatus = newVal.refundAuditStatus
          // }
          // if (newVal.invoiceStatus !== null) {
          //   this.invoiceInfo.invoiceStatus = newVal.invoiceStatus
          // }
          // this.invoiceInfo.createBy = newVal.createBy
          // this.invoiceInfo.createTime = newVal.createTime
          // this.invoiceInfo.invoiceRecordId = newVal.invoiceRecordId
          // this.invoiceInfo.invoiceAmount = newVal.invoiceAmount
          // this.invoiceInfo.invoiceType = newVal.invoiceType
          // this.invoiceInfo.invoiceNumber = newVal.invoiceNumber
          // this.invoiceInfo.remark = newVal.remark
        }
      },
      immediate: true
    },
  },
  methods: {
    getInvoiceColor,
    toggleSection(section) {
      this.sectionOpen[section] = !this.sectionOpen[section];
    },
    cancel() {
      this.$emit('submit', 'cancel')
    },
    close1() {
      this.$nextTick(() => {
        this.showContractDetails = false
      })
    },
    handle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          refundAudit(this.form).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$emit('submit', 'confirm')
              if (this.form.status === 'SUCCESS') {
                this.$messageUi.success('已通过')
              } else {
                this.$messageUi.success('已驳回')
              }
              this.$store.commit('right/setChangeRed', true)
            }
          }).catch(err => {
            this.loading = false
          })
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      });
    },
    openContractDialog(contractNumber) {
      let param = {}
      let data = {
        "query#contractNumber.EQ": contractNumber
      }
      getContractPage(param, data).then(res => {
        if (res.code === 200) {
          if (res.data.records.length === 0) {
            this.$messageUi.error("打开合同详情失败")
          } else {
            this.ContractDetail = res.data.records[0]
            this.showContractDetails = true
          }
        }
      }).catch(error => {
      })
    },
    async download(id) {
      try {
        let url = `${baseURL}/invoice-info/attachment/${id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    async preview(id) {
      try {
        this.fileInfo = await attachmentTickets(id);
        if (this.fileInfo.file) {
          this.showFile = true
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tickets-check-dialog {
  ::v-deep .audit-dialog {
    .el-dialog__header {

      padding: 15px 20px;

      .el-dialog__title {
        font-weight: 600;
      }


    }

    .el-dialog__body {
      padding: 20px;
    }
  }
}

@import "@/assets/css/mixins.scss";
@import "@/assets/css/detail.css";

.el-dialog-div {
  max-height: 90vh;
  overflow-y: auto;
  padding-right: 5px;

  @include thin-scrollbar(8px, #888);
}

.audit-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
}

.audit-form {
  padding: 16px;
}
</style>
